/* eslint-disable no-restricted-globals */
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App/App.jsx";

if (process.env.NODE_ENV === "production" && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: "production",
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Drop errors thrown by browser extension scripts (not Pinpoint code).
    // Safari masks extension script URLs as webkit-masked-url://hidden/.
    denyUrls: [
      /^webkit-masked-url:\/\//,
      /^safari-(web-)?extension:\/\//,
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
    ],
    // Extension scripts that fail to reach their background page reject with
    // this message and no stack trace, so denyUrls has nothing to match.
    ignoreErrors: [/runtime\.sendMessage\(\)/],
    integrations: [
      Sentry.replayIntegration(),
      // Admin-only "Report a problem" button. autoInject: false means no page
      // shows it by default; the admin area mounts it via useAdminFeedback.
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: "light",
        showBranding: false,
        triggerLabel: "Report a problem",
        formTitle: "Report a problem",
        messagePlaceholder: "What went wrong? Include the space and student UID if relevant.",
        submitButtonLabel: "Send report",
        successMessageText: "Thanks — the Pinpoint team will take a look.",
      }),
    ],
  });
}

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
